var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBooking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 24V4a4 4 0 0 1 4-4h20a4 4 0 0 1 4 4v20a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4z",
    fill: "#424141"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FCFCFC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.485 11.907v8.069c0 .195.184.353.411.353h2.23a.42.42 0 0 0 .375-.208c.266-.507.855-.834 1.5-.834.647 0 1.235.327 1.5.834a.42.42 0 0 0 .376.208h2.23c.227 0 .411-.158.411-.353v-8.069H9.485zM18.107 7.67h-2.23a.412.412 0 0 0-.375.243c-.266.59-.854.97-1.5.97s-1.235-.38-1.5-.97a.412.412 0 0 0-.376-.242h-2.23a.411.411 0 0 0-.411.41v3.005h9.033V8.082a.411.411 0 0 0-.411-.411z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooking);
export default __webpack_public_path__ + "static/media/booking.070d4d3bb2a6f9adcd72c76bfb9db6ba.svg";
export { ForwardRef as ReactComponent };